import { IPdfElement } from '../../types/pdfTemplateTypes';

export type LayerMoveAction = 'forward' | 'backward' | 'front' | 'back';

export function normalizeElementZIndexes(elements: IPdfElement[]): IPdfElement[] {
  return [...elements]
    .sort((a, b) => (a.zIndex ?? 0) - (b.zIndex ?? 0))
    .map((element, index) => ({ ...element, zIndex: index }));
}

function assignElementZIndexes(elements: IPdfElement[]): IPdfElement[] {
  return elements.map((element, index) => ({ ...element, zIndex: index }));
}

export function getLayerOrderedElements(elements: IPdfElement[]): IPdfElement[] {
  return normalizeElementZIndexes(elements).sort((a, b) => (b.zIndex ?? 0) - (a.zIndex ?? 0));
}

export function moveElementLayer(elements: IPdfElement[], elementId: string, action: LayerMoveAction): IPdfElement[] {
  const normalized = normalizeElementZIndexes(elements);
  const currentIndex = normalized.findIndex((element) => element.id === elementId);
  if (currentIndex < 0) return elements;
  if (normalized[currentIndex].locked) return elements;

  const next = [...normalized];
  const [moved] = next.splice(currentIndex, 1);

  if (action === 'front') {
    next.push(moved);
  } else if (action === 'back') {
    next.unshift(moved);
  } else if (action === 'forward') {
    next.splice(Math.min(next.length, currentIndex + 1), 0, moved);
  } else {
    next.splice(Math.max(0, currentIndex - 1), 0, moved);
  }

  return assignElementZIndexes(next);
}
